import api from '../lib/axios';

/**
 * Classe base para módulos de API
 * Fornece métodos CRUD padrão e estrutura consistente
 */
export class BaseApiModule {
  constructor(resourceName) {
    this.resourceName = resourceName;
    this.baseUrl = `/${resourceName}`;
  }

  /**
   * Listar recursos com opções de filtro e paginação
   */
  list(params = {}) {
    return api.get(this.baseUrl, { params });
  }

  /**
   * Obter recurso específico por ID
   */
  get(id) {
    return api.get(`${this.baseUrl}/${id}`);
  }

  /**
   * Criar novo recurso
   */
  create(data) {
    return api.post(this.baseUrl, data);
  }

  /**
   * Atualizar recurso existente
   */
  update(id, data, config) {
    return config ? api.put(`${this.baseUrl}/${id}`, data, config) : api.put(`${this.baseUrl}/${id}`, data);
  }

  /**
   * Atualização parcial de recurso
   */
  patch(id, data) {
    return api.patch(`${this.baseUrl}/${id}`, data);
  }

  /**
   * Excluir recurso
   */
  delete(id) {
    return api.delete(`${this.baseUrl}/${id}`);
  }

  /**
   * Buscar recursos com query personalizada
   */
  search(query, params = {}) {
    return api.get(`${this.baseUrl}/search`, {
      params: { q: query, ...params },
    });
  }

  /**
   * Ação customizada no recurso
   */
  action(action, id = null, data = {}) {
    const url = id ? `${this.baseUrl}/${id}/${action}` : `${this.baseUrl}/${action}`;
    return api.post(url, data);
  }
}

/**
 * Factory para criar módulos de API
 */
export const createApiModule = (resourceName, customMethods = {}) => {
  const baseModule = new BaseApiModule(resourceName);

  return {
    list: (params = {}) => baseModule.list(params),
    get: (id) => baseModule.get(id),
    create: (data) => baseModule.create(data),
    update: (id, data) => baseModule.update(id, data),
    patch: (id, data) => baseModule.patch(id, data),
    delete: (id) => baseModule.delete(id),
    search: (query, params = {}) => baseModule.search(query, params),
    action: (action, id = null, data = {}) => baseModule.action(action, id, data),
    ...customMethods,
  };
};
